import '../App.css'
import './partners.css';
import iconSecton from '../img/icon-section.png';
import logoTsubameLab from '../img/logo-tsubameLabData';
import { useEffect, useState, useMemo } from 'react';

const partnersList = [
  {
    name: "東京科学大学イノベーションデザイン機構",
    logo: require('../img/logo-indest.png'),
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://www.idp.ori.titech.ac.jp/indest/top/"
  },
  {
    name: "株式会社スムージースタジオ",
    logo: require('../img/logo-smoothie.png'),
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://smoothiestudio.co.jp/"
  },
  {
    name: "ビネット＆クラリティ合同会社",
    logo: require('../img/logo-vignetteClarity.png'),
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://vigne-cla.com/"
  },
  {
    name: "Tsubame Lab株式会社",
    logo: logoTsubameLab,
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://www.tsubamelab.com/"
  },
  {
    name: "株式会社grubio",
    logo: require('../img/logo-grubio.png'),
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://grubio.jp/"
  },
  {
    name: "wavelogy株式会社",
    logo: require('../img/logo-wavelogy.jpg'),
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://wavelogy.jp/"
  },
  {
    name: "GoMA株式会社",
    logo: require('../img/logo-GoMA.jpg'),
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://www.go-ma.co.jp/"
  },
  {
    name: "AIdea",
    logo: require('../img/logo-aidea.png'),
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://www.aideagoesup.jp/"
  },
  {
    name: "Artemis",
    logo: require('../img/logo-artemis.jpg'),
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://x.com/Artemis572316"
  },
  {
    name: "株式会社ゆらりす",
    logo: require('../img/logo-yurarisu.png'),
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://www.yurarisu.com/"
  },
  {
    name: "株式会社Unito",
    logo: require('../img/logo-unito_v2.png'),
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://unito.life/company/"
  },
  {
    name: "株式会社INSHI",
    logo: require('../img/logo-INSHI.png'),
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://inshi-jyuku.com/"
  },
  {
    name: "株式会社地道",
    logo: require('../img/logo-jimichi.png'),
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://www.j1michi.com/"
  },
  {
    name: "株式会社Chordix",
    logo: require('../img/logo-chordix.png'),
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://chordix-ai.com/"
  },
  {
    name: "株式会社WAKUMAX",
    logo: require('../img/logo-wakumax.png'),
    gradient: "linear-gradient(135deg, rgba(158, 158, 158, 0.2), rgba(158,158,158,0.2))",
    hp_url: "https://www.wakumax.com/"
  },
];

function shuffleArray(array) {
  const shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}


function Partners() {
  const [isMobile, setIsMobile] = useState(false);
  const [time, setTime] = useState(0);

  const shuffledPartners = useMemo(() => {
    const [first, ...rest] = partnersList;
    return [first, ...shuffleArray(rest)];
  }, []);

  const visiblePartners = isMobile ? shuffledPartners.slice(0, 4) : shuffledPartners;
  const hasMorePartners = isMobile && shuffledPartners.length > visiblePartners.length;

  

  // 定期的にtimeを更新してアニメーション
  useEffect(() => {
      const interval = setInterval(() => {
          setTime((t) => t + 0.03);
      }, 1000 / 30); // 30fps
      return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile(); // 初期チェック
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  // const visiblePartners = isMobile ? partnersList.slice(0, 4) : partnersList;
  // const hasMorePartners = isMobile && partnersList.length > visiblePartners.length;

  return (
    <div className="partners">
      <section id="partners">
        <img src={iconSecton} alt="icon-section" className="icon-section" />
        <h1>Partners</h1>
      </section>
      <div className='partners-container'>
        <div className="wavy-lines-background">
        </div>
        <div className="partners-list">
          {isMobile && hasMorePartners ? (
            <RenderMobileSlider partnersList={partnersList} />
          ) : (
            <>
              {visiblePartners.map((partner, index) => (
                <a href={partner.hp_url} target="_blank" rel="noopener noreferrer" key={index}>
                  <div
                    className="partner-card"
                    style={{ '--hover-bg': partner.gradient }}
                  >
                    <img src={partner.logo} alt={partner.name} className="partner-logo" />
                  </div>
                </a>
              ))}
              {hasMorePartners && (
                <div className="more-partners-text">
                  他にもいろいろなパートナーがいます！
                </div>
              )}
            </>
          )}
        </div>


      </div>
    </div>
  );
}

export default Partners;

function RenderMobileSlider({ partnersList }) {
  const chunkSize = 4;
  const slideInterval = 5000;
  const chunks = [];
  for (let i = 0; i < partnersList.length; i += chunkSize) {
    chunks.push(partnersList.slice(i, i + chunkSize));
  }

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isPlaying, setIsPlaying] = useState(true);

  useEffect(() => {
    if (!isPlaying) return;
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % chunks.length);
    }, slideInterval);
    return () => clearInterval(interval);
  }, [isPlaying, chunks.length]);

  const goToSlide = (index) => {
    setCurrentIndex(index);
    setIsPlaying(false); // dotクリック時は一時停止
  };

  const togglePlay = () => {
    setIsPlaying((prev) => !prev);
  };

  return (
    <div className="partners-slider-wrapper">
      <div
        className="partners-slider"
        style={{
          width: `${chunks.length * 100}%`,
          transform: `translateX(-${currentIndex * (100 / chunks.length)}%)`,
          '--chunk-count': chunks.length
        }}
      >
      {chunks.map((group, groupIndex) => (
        <div className="partners-slide" key={groupIndex}>
          {group.map((partner, index) => (
            <a href={partner.hp_url} target="_blank" rel="noopener noreferrer" key={index}>
              <div
                className="partner-card"
                style={{ '--hover-bg': partner.gradient }}
              >
                <img src={partner.logo} alt={partner.name} className="partner-logo" />
              </div>
            </a>
          ))}
        </div>
        ))}
      </div>
      <div className="partners-dots">
        <span className="play-icon-button" onClick={togglePlay} title={isPlaying ? '一時停止' : '再生'}>
          {isPlaying ? (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
              <rect x="6" y="4" width="4" height="16" rx="1"/>
              <rect x="14" y="4" width="4" height="16" rx="1"/>
            </svg>
          ) : (
            <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor" style={{ display: 'inline-block', verticalAlign: 'middle' }}>
              <polygon points="6,4 20,12 6,20"/>
            </svg>
          )}
        </span>
        {chunks.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === currentIndex ? 'active' : ''}`}
            onClick={() => goToSlide(i)}
          />
        ))}
      </div>
    </div>
  );
}
